import './App.css';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { resolveFeedUri } from './BskyLoader';

function BskyProfile() {
  const [searchParams] = useSearchParams();
  const feed = searchParams.get("feed");
  const user = searchParams.get("user") || "pics.yernemm.xyz";

  const [view, setView] = useState(null); // { mode, ... }

  useEffect(() => {
    let cancelled = false;

    async function loadFeed() {
      try {
        const feedUri = await resolveFeedUri({ user, feed });
        const res = await fetch(
          `https://api.bsky.app/xrpc/app.bsky.feed.getFeedGenerator?feed=${encodeURIComponent(feedUri)}`
        );
        const data = await res.json();
        if (!cancelled && data.view) setView({ mode: 'feed', ...data.view });
      } catch (err) {
        console.error("Error loading feed info:", err);
      }
    }

    async function loadProfile() {
      try {
        const res = await fetch(
          `https://api.bsky.app/xrpc/app.bsky.actor.getProfile?actor=${encodeURIComponent(user)}`
        );
        const data = await res.json();
        if (!cancelled) setView({ mode: 'profile', ...data });
      } catch (err) {
        console.error("Error loading profile:", err);
      }
    }

    setView(null);
    if (feed) loadFeed();
    else loadProfile();

    return () => { cancelled = true; };
  }, [user, feed]);

  if (view?.mode === 'feed') {
    const creatorName = view.creator?.displayName || view.creator?.handle;
    return (
      <div>
        <h1 style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <img
            src={view.avatar || ""}
            alt="Feed Avatar"
            style={{ width: "100px", height: "100px", borderRadius: "12px", display: "inline-block", verticalAlign: "middle" }}
          />
          {view.displayName || "Loading..."}
        </h1>
        {creatorName && (
          <p style={{ fontSize: "0.85em", color: "#a6adc8", marginTop: "-8px" }}>
            by {creatorName}
          </p>
        )}
        <hr />
        <p style={{ whiteSpace: "pre-wrap" }}>{view.description || ""}</p>
      </div>
    );
  }

  return (
    <div>
      <h1 style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <img
          src={view?.avatar || ""}
          alt="Profile Avatar"
          style={{ width: "100px", height: "100px", borderRadius: "50%", display: "inline-block", verticalAlign: "middle" }}
        />
        {view?.displayName || "Loading..."}
      </h1>
      <hr />
      <p>{view?.description || ""}</p>
    </div>
  );
}

export default BskyProfile;
